import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import { Trans } from '@lingui/macro'

import styles from './index.module.css'

library.add(faArrowDown)

const Download = ({ url, title }) => {
  return (
    <Menu.Item>
      {({ active, ...props }) => (
        <a href={url} download={title}>
          <button
            className={classNames(
              active ? styles.active : styles.notActive,
              styles.item
            )}
            {...props}
          >
            <FontAwesomeIcon
              className={styles.icon}
              icon={['fas', 'arrow-down']}
            />
            <Trans>Download</Trans>
          </button>
        </a>
      )}
    </Menu.Item>
  )
}

export default Download
